import * as Types from '../../../../generated/types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type DataObjectThumbnailFragment = { __typename: 'DataObjectByUuid', id: string, mediaType?: string | null, state: Types.DataObjectState, downloadUrl: string, thumbnail?: { __typename: 'DataObjectByUuidThumbnail', downloadUrl: string } | null, thumbnailProcessingJob?: { __typename: 'DataObjectByUuidThumbnailProcessingJob', state: Types.JobState } | null };

export type QueryDataObjectThumbnailsQueryVariables = Types.Exact<{
  ids: Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input'];
  resolution: Types.DownloadResolution;
}>;


export type QueryDataObjectThumbnailsQuery = { __typename: 'Query', dataObjectsById: Array<{ __typename: 'DataObjectByUuid', id: string, mediaType?: string | null, state: Types.DataObjectState, downloadUrl: string, thumbnail?: { __typename: 'DataObjectByUuidThumbnail', downloadUrl: string } | null, thumbnailProcessingJob?: { __typename: 'DataObjectByUuidThumbnailProcessingJob', state: Types.JobState } | null }> };

export const DataObjectThumbnailFragmentDoc = gql`
    fragment DataObjectThumbnail on DataObjectByUuid {
  id
  mediaType
  state
  downloadUrl
  thumbnail(fileType: jpg, resolution: $resolution) {
    downloadUrl
  }
  thumbnailProcessingJob {
    state
  }
}
    `;
export const QueryDataObjectThumbnailsDocument = gql`
    query queryDataObjectThumbnails($ids: [ID!]!, $resolution: DownloadResolution!) {
  dataObjectsById(ids: $ids) {
    ...DataObjectThumbnail
  }
}
    ${DataObjectThumbnailFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class QueryDataObjectThumbnailsGQL extends Apollo.Query<QueryDataObjectThumbnailsQuery, QueryDataObjectThumbnailsQueryVariables> {
    override document = QueryDataObjectThumbnailsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }